module.exports = "pegasus_template/assets/tech/small/9.png";